import React from "react";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import { PAGE_URLS } from "constants/common";
import Login from "@pages/login/Login";
import AuthLayout from "@features/common/layouts/authLayout/AuthLayout";
import ForgotPassword from "@pages/forgotPassword/ForgotPassword";
import NotFoundPage from "@pages/error/404/NotFoundPage";
import SelectCorporate from "@pages/selectCorporate/SelectCorporate";
import IssueCredits from "@pages/issueCredits/IssueCredits";
import PrivateRoute from "./PrivateRoute";
import CommonLayout from "@features/common/layouts/commonLayout/CommonLayout";
import ResetPasswordPage from "@pages/resetPassword/ResetPassword";
import CreditsListing from "@pages/creditsListing/CreditsListing";
import IssueCreditsSuccess from "@pages/issueCreditsSuccess/IssueCreditsSuccess";
import CorporateLayout from "@features/common/layouts/corporateLayout/CorporateLayout";
import CreditReports from "@pages/creditReports/CreditReports";
import RequireCorporateGuard from "@features/common/layouts/RequireCorporateGuard";
import Drafts from "@pages/draft/Drafts";
import Settings from "@pages/settings/Settings";
import UserManagement from "@pages/userManagement/UserManagement";
import SendReminder from "@pages/sendReminder/SendReminder";
import Reports from "@pages/reports/Reports";
import AccessControlGuard from "@features/common/layouts/accessControlGuard/AccessControlGuard";
import AccessDenied from "@pages/error/403/AccessDenied";
import Error500 from "@pages/error/500/Error500";

export default function Router() {
  return (
    <BrowserRouter>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Public routes */}
          <Route element={<AuthLayout />}>
            <Route path={PAGE_URLS.LOGIN} element={<Login />} />
            <Route
              path={PAGE_URLS.FORGOT_PASSWORD}
              element={<ForgotPassword />}
            />
            <Route
              path={PAGE_URLS.RESET_PASSWORD}
              element={<ResetPasswordPage />}
            />
          </Route>

          {/* Private routes with CommonLayout */}
          <Route element={<PrivateRoute />}>
            <Route element={<CorporateLayout />}>
              <Route
                path={PAGE_URLS.SELECT_CORPORATE}
                element={<SelectCorporate />}
              />
            </Route>

            {/* Protect all corporate-required routes */}
            <Route element={<AccessControlGuard />}>
              <Route
                element={
                  <RequireCorporateGuard>
                    <CommonLayout />
                  </RequireCorporateGuard>
                }
              >
                <Route
                  path={PAGE_URLS.ISSUE_CREDITS}
                  element={<IssueCredits />}
                />
                <Route
                  path={PAGE_URLS.CREDITS_LISTING}
                  element={<CreditsListing />}
                />
                <Route
                  path={PAGE_URLS.ISSUE_CREDITS_SUCCESS}
                  element={<IssueCreditsSuccess />}
                />
                <Route path={PAGE_URLS.DRAFTS} element={<Drafts />} />
                <Route path={PAGE_URLS.REPORTS} element={<Reports />} />
                <Route
                  path={PAGE_URLS.CREDIT_REPORTS}
                  element={<CreditReports />}
                />
                <Route path={PAGE_URLS.SETTINGS} element={<Settings />} />
                <Route
                  path={PAGE_URLS.USER_MANAGEMENT}
                  element={<UserManagement />}
                />
                <Route
                  path={PAGE_URLS.SEND_REMINDER}
                  element={<SendReminder />}
                />
              </Route>
            </Route>
          </Route>

          {/* Error and fallback routes */}
          <Route path={PAGE_URLS.NOT_FOUND} element={<NotFoundPage />} />
          <Route path={PAGE_URLS.ACCESS_DENIED} element={<AccessDenied />} />
          <Route path={PAGE_URLS.ERROR_500} element={<Error500 />} />       

          <Route path="/" element={<Navigate to={PAGE_URLS.LOGIN} />} />
          <Route
            path="*"
            element={<Navigate to={PAGE_URLS.NOT_FOUND} replace />}
          />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}
